export const headerStyles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    flexWrap: "wrap",
    gap: 2,
    mb: "15px",
    pr: "8px",
  },

  tabsContainer: {
    minHeight: "auto",
    "& .MuiTabs-indicator": {
      height: "2px",
      backgroundColor: "#257C6D",
    },
    "& .MuiTabs-scroller": {
      overflowX: "auto !important",
      "&::-webkit-scrollbar": {
        display: "none",
      },
      scrollbarWidth: "none",
    },
  },

  tab: {
    minHeight: "auto",
    padding: "3px 5px",
    minWidth: "auto",
    marginRight: "20px",
    fontSize: "16px",
    textTransform: "capitalize",
    color: "#3E3F4C",
    opacity: 1,
    "&.Mui-selected": {
      color: "#257C6D",
    },
    "&:hover": {
      backgroundColor: "#E1F0ED",
    },
  },
  tabIndicator: {
    backgroundColor: "#257C6D",
  },

  searchContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "auto",
  },

  searchInput: {
    "& .MuiOutlinedInput-root": {
      width: {
        xl: "260px",
        lg: "260px",
        md: "250px",
        sm: "240px",
        xs: "100%",
      },
      height: "39px",
      fontWeight: 400,
      fontSize: "15px",
      color: "rgba(62, 63, 76, 0.7)",
      borderRadius: "8px",
      backgroundColor: "#ffffff",
      "& fieldset": {
        borderWidth: "1px",
        borderColor: "#EAEAEA",
      },
      "&:hover fieldset": {
        borderWidth: "1px",
        borderColor: "#3e3f4c",
      },
      "&.Mui-focused fieldset": {
        borderWidth: "1px",
        borderColor: "#3e3f4c",
      },
    },
  },
};
